export enum CarePlanStatus {
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  VOID = 'VOID',
}
